export default function LockIcon() {
  return (
    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M20.5 28.9158C22.0004 28.9158 23.2167 27.6995 23.2167 26.1991C23.2167 24.6987 22.0004 23.4824 20.5 23.4824C18.9996 23.4824 17.7833 24.6987 17.7833 26.1991C17.7833 27.6995 18.9996 28.9158 20.5 28.9158Z"
        fill="#4F55FD"
      />
      <path
        d="M28.25 15.7324H12.75C5.91671 15.7324 3.83337 17.8158 3.83337 24.6491V27.7491C3.83337 34.5824 5.91671 36.6658 12.75 36.6658H28.25C35.0834 36.6658 37.1667 34.5824 37.1667 27.7491V24.6491C37.1667 17.8158 35.0834 15.7324 28.25 15.7324ZM20.5 31.2324C17.7167 31.2324 15.4667 28.9658 15.4667 26.1991C15.4667 23.4324 17.7167 21.1658 20.5 21.1658C23.2834 21.1658 25.5334 23.4324 25.5334 26.1991C25.5334 28.9658 23.2834 31.2324 20.5 31.2324Z"
        fill="#4F55FD"
      />
      <path
        opacity="0.4"
        d="M12.3667 15.7507V13.8007C12.3667 8.91732 13.75 5.66732 20.5 5.66732C27.25 5.66732 28.6333 8.91732 28.6333 13.8007V15.7507C29.4833 15.7673 30.25 15.8007 30.9667 15.9007V13.8007C30.9667 9.30065 29.8833 3.33398 20.5 3.33398C11.1167 3.33398 10.0333 9.30065 10.0333 13.8007V15.884C10.7333 15.8007 11.5167 15.7507 12.3667 15.7507Z"
        fill="#4F55FD"
      />
    </svg>
  );
}
